/**
 * Utility functions for handling different loaders based on domain/tenant
 * Exposes configuration to window object for use by index.html
 *
 * CONFIGURATION ARRAYS: Defined below and exposed to window
 */

// Import loaders
import defaultLoader from "../assets/images/loader-6.gif";
import ltmLoader from "../assets/images/LTM_loader_animated 18.svg";

/**
 * PRIMARY Configuration: Add domains where LTM loader should be displayed
 */
const LTM_DOMAINS = [
  "lighthouse.ltm.com",
  "lighthouse.ltimindtree.com",
  "dev1learner.shotclasses.com",
  "localhost:3000",
  "qa-learner.shotclasses.com",
];

/**
 * PRIMARY Configuration: Add tenant slug names where LTM loader should be displayed
 */
const LTM_TENANTS = [];

// Expose configuration to window object for use by index.html
if (typeof window !== "undefined") {
  window.LTM_DOMAINS = LTM_DOMAINS;
  window.LTM_TENANTS = LTM_TENANTS;
}

/**
 * Get the current LTM domains configuration
 * @returns {Array} - Array of LTM domains
 */
const getLTMDomains = () => {
  return LTM_DOMAINS;
};

/**
 * Get the current LTM tenants configuration
 * @returns {Array} - Array of LTM tenants
 */
const getLTMTenants = () => {
  return LTM_TENANTS;
};

/**
 * Check if current domain matches any configured LTM domains
 * Uses shared window function if available, otherwise local logic
 * @returns {boolean} - True if current domain is in LTM domains list
 */
const isLTMDomain = () => {
  const currentUrl = window.location.href.toLowerCase();
  return LTM_DOMAINS.some((domain) =>
    currentUrl.includes(domain.toLowerCase()),
  );
};

/**
 * Check if current tenant matches any configured LTM tenants
 * @returns {boolean} - True if current tenant is in LTM tenants list
 */
const isLTMTenant = () => {
  const tenantSlugName = localStorage.getItem("tenantSlugName");
  if (!tenantSlugName) return false;

  return LTM_TENANTS.some(
    (tenant) => tenantSlugName.toLowerCase() === tenant.toLowerCase(),
  );
};

/**
 * Get the appropriate loader based on current domain/tenant
 * Uses shared window function if available, otherwise local logic
 * @returns {string} - Path to the appropriate loader gif
 */
export const getAppropriateLoader = () => {
  // Check if current domain or tenant is configured for LTM loader
  const shouldUseLTMLoader = isLTMDomain() || isLTMTenant();

  // Return LTM loader for configured domains/tenants, default loader for others
  return shouldUseLTMLoader ? ltmLoader : defaultLoader;
};

/**
 * Check if current environment should use LTM branding
 * @returns {boolean} - True if should use LTM loader/branding
 */
export const isLTMEnvironment = () => {
  return isLTMDomain() || isLTMTenant();
};
